/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import useStyles from "./styles";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	getNotificationDetailAction,
	setNotificationDetailAction
} from "store/actions/NotificationPageAction";

const NewsPage = props => {
	const { getNotificationDetail, notificationDetail, setNotificationDetail } =
		props;
	const history = useHistory();
	const classes = useStyles();
	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);

	useEffect(() => {
		return () => {
			setNotificationDetail({});
		};
	}, []);

	useEffect(() => {
		if (idNotification) {
			getNotificationDetail(idNotification);
		}
	}, [idNotification]);

	return (
		<Grid container style={{ padding: 16 }}>
			<Grid classes={{ root: classes.title }}>
				{notificationDetail?.content?.title}
			</Grid>

			<Grid style={{ marginBottom: 10, width: "100%" }}>
				<Grid style={{ width: "100%" }}>Nội dung thông báo: </Grid>
				<Grid
					classes={{ root: classes.text }}
					style={{
						whiteSpace: "pre-wrap"
					}}
					dangerouslySetInnerHTML={{
						__html: notificationDetail?.content?.content
					}}
				/>
			</Grid>
			<Grid style={{ marginBottom: 10, width: "100%" }}>
				<Grid style={{ width: "100%" }}>Văn bản thông báo: </Grid>
				<Grid
					classes={{ root: classes.text }}
					style={{
						whiteSpace: "pre-wrap"
					}}
					dangerouslySetInnerHTML={{
						__html: notificationDetail?.content?.subTitle
					}}
				/>
			</Grid>
			<Grid style={{ marginBottom: 10, width: "100%" }}>
				<Grid style={{ width: "100%" }}>Link thông báo: </Grid>
				<Grid classes={{ root: classes.text }}>
					{notificationDetail?.content?.url}
				</Grid>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		notificationDetail: state.notificationPageReducer.notificationDetail
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getNotificationDetail: data => {
			dispatch(getNotificationDetailAction(data));
		},
		setNotificationDetail: data => {
			dispatch(setNotificationDetailAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsPage);
